import { useQuery } from '@tanstack/react-query';
import { getShops } from '../../api/shops/getShops';

export const useGetShops = () => {
  const { data, isSuccess, isLoading, isError } = useQuery({
    queryKey: ['getShops'],
    queryFn: () => getShops(),
  });

  return {
    shops: data,
    isGetShopsSuccess: isSuccess,
    isGetShopsLoading: isLoading,
    isGetShopsError: isError,
  };
};
